<template>
  <div class="grid scroll-div">
    <div class="grid-title bg-primary">
      <h4 class="text-bold text-white">
        Next To Order
      </h4>
      <FabricCalculationInfo>
        <template #title
          >This is a list of fabric that need to order as next.</template
        >
        <template #content>
          <div class="calculation-info-container">
            <div class="title">Filters</div>
            <div class="description">
              The table displays fabrics that match any of these filters.
            </div>
            <code>
              - always available && not placed order <br />
              - pieces available && future keep && not placed order <br />
              - (available OR soon_sold_out_coming_back OR sold_out_coming_back) && not inactive for 2 months && future keep && not placed order
            </code>
          </div>

          <div class="calculation-info-container">
            <div class="title">Est. Sold out date</div>
            <div class="description">
              Estimated sold out date is the date when the fabric is expected to
              be sold out or unavailable for purchase.
              <br />
              If fabric is already sold out, then it will show sold out date.
              <br />
              If fabric is overwritten, then it will show 'Overwritten'
            </div>
            <code>
              const LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED = 30;<br />
              $average = max($averageUsage30days, $averageUsage60days,
              $averageSale30days, $averageSale60days);<br />
              $daysLeftForStock = ($fabricInStock -
              LENGTH_UNTIL_SOLD_OUT_STATUS_TRIGGERED) / $average;<br />
              $result = formatDaysToDate($daysLeftForStock);
            </code>
          </div>

          <div class="calculation-info-container">
            <div class="title">Supplier</div>
            <div class="description">
              Supplier refers to the person who supplied the fabrics on the last
              order.
            </div>
          </div>

          <div class="calculation-info-container">
            <div class="title">Deliver time of supplier</div>
            <div class="description">
              Deliver time of supplier is the amount of days it takes for the
              supplier to fulfill the order.
            </div>
            <code>
              const BUFFER_VALUE_FOR_SUPPLIER_EFFICIENCY = 20; <br />
              $supplierEfficiencyInDays = $supplierEfficiency * 7 <br />
              $result = $supplierEfficiencyInDays (1 +
              BUFFER_VALUE_FOR_SUPPLIER_EFFICIENCY / 100)
            </code>
          </div>

          <div class="calculation-info-container">
            <div class="title">Order to place within x days</div>
            <div class="description">
              Order to place within x days is the days we have left to order the
              fabric, without risking that it will move to sold out.
            </div>
            <code> $result = $daysLeftForStock - $deliverTime; </code>
          </div>

          <div class="calculation-info-container">
            <div class="title">Usage of the last 30 days</div>
            <div class="description">
              Usage of the last 30 days is the maximum usage of length (
              <i>In Meter</i> ) in last 30 days.
            </div>
            <code> $result = max($totalSale30days, $totalUsage30days) </code>
          </div>
        </template>
      </FabricCalculationInfo>
    </div>
    <div class="grid-body p-0">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="pointer" @click="sort('id')" width="150">
              Fabric
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="pointer" @click="sort('out_of_stock_date')" width="150">
              Est. Sold out date
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('supplier_name')">
              Supplier
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('lead_time')">
              Delivery time of supplier
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th
              class="text-center pointer"
              @click="customSort('delta_sold_out_and_delivery')"
            >
              Order to place within x days
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('max_usage_in_30d')">
              Usage of the last 30 days
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fabric, index) in sortedFabrics" :key="index">
            <td class="show-status">
              <router-link :to="'/fabric/update/' + fabric.id"
                >{{ $Fabric.getCode(fabric.id) }} - {{ fabric.name }}
              </router-link>
              <div
                v-if="fabric.status == 'sold_out_coming_back'"
                class="status-label"
              >
                Out
              </div>
            </td>
            <td class="text-center">
              {{ formatOutOfStockDate(fabric) }}
            </td>
            <td>{{ fabric.supplier_name }}</td>
            <td class="text-center">
              {{ convertDaysToDHFormat(fabric.lead_time) }}
            </td>
            <td class="text-center">
              {{ convertDaysToDHFormat(fabric.delta_sold_out_and_delivery) }}
            </td>
            <td class="text-center">{{ fabric.max_usage_in_30d }} m</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import FabricCalculationInfo from "./FabricCalculationInfo";
export default {
  components: { FabricCalculationInfo },
  props: ["pageData"],
  data() {
    return {
      showCalculationInfo: false,
      sortedFabrics: [],
      sortType: "desc",
    };
  },
  methods: {
    sort(column) {
      this.sortType = this.sortType == "asc" ? "desc" : "asc";
      this.sortedFabrics = _.orderBy(
        this.sortedFabrics,
        [column],
        [this.sortType]
      );
    },
    convertDaysToDHFormat(durationInDays) {
      if (durationInDays == null) {
        return "-";
      }

      if (durationInDays == 0) {
        return "0 day";
      }

      let days = Math.floor(Math.abs(durationInDays));
      let hours = Math.floor((Math.abs(durationInDays) % 1) * 24);
      let output = "";

      if (durationInDays < 0) {
        output += "-";
      }
      if (days > 0) {
        output += `${days}d`;
      }
      if (hours > 0) {
        output += `${output.length > 0 ? " " : ""}${hours}h`;
      }

      return output;
    },
    customSort(column) {
      let sortType = this.sortType == "asc" ? "desc" : "asc";
      let data = this.sortedFabrics;
      let result = data.sort((a, b) => {
        const valueA = a[column];
        const valueB = b[column];

        // Handle null values
        if (valueA === null && valueB === null) return 0;
        if (valueA === null) return sortType === "asc" ? -1 : 1;
        if (valueB === null) return sortType === "asc" ? 1 : -1;

        // Compare the values based on the sort type
        if (sortType === "asc") {
          if (valueA < 0 && valueB >= 0) return -1;
          if (valueA >= 0 && valueB < 0) return 1;
          return valueA - valueB;
        } else {
          if (valueA < 0 && valueB >= 0) return 1;
          if (valueA >= 0 && valueB < 0) return -1;
          return valueB - valueA;
        }
      });
      this.sortedFabrics = result;
      this.sortType = sortType;
    },
    formatOutOfStockDate(fabric) {
      if(fabric.pieces_available || fabric.always_available) {
        return 'Overwritten'
      } else if(fabric.out_of_stock_date > 0 ){
        return moment.unix(fabric.out_of_stock_date).format('DD MMM, YYYY')
      } else {
        return 'Something wrong'
      }
    },
  },
  watch: {
    "pageData.fabricNeedToOrder": function () {
      let fabricNeedToOrder = this.pageData.fabricNeedToOrder;
      if (fabricNeedToOrder) {
        fabricNeedToOrder = fabricNeedToOrder.map((fabric) => {
          fabric.max_usage_in_30d = Math.max(
            fabric.total_sales_30d,
            fabric.total_usage_30d
          ).toFixed(2);
          if (fabric.sold_out_date && fabric.status == "sold_out_coming_back") {
            fabric.out_of_stock_date = moment(
              fabric.sold_out_date,
              "YYYY-MM-DD H:mm:ss"
            ).unix();
          }
          return fabric;
        });
        this.sortedFabrics = _.orderBy(fabricNeedToOrder, "out_of_stock_date", [
          this.sortType,
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;

  h4 {
    margin-top: 0;
    width: 100%;
  }
}

thead {
  position: relative;
  z-index: 1;
}

.show-status {
  position: relative;
  overflow: hidden;
  .status-label {
    position: absolute;
    bottom: 3px;
    right: -14px;
    width: 45px;
    transform: rotate(315deg);
    font-size: 8px;
    background-color: red;
    color: white;
    text-align: center;
  }
}
</style>
